export default __webpack_public_path__ + "static/media/Avatar-10.a73bc2a3.png";